import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import MainNavigation from 'components/Credit24/SelfService/Navigation/MainNavigation';
import LogoutButton from 'components/Credit24/SelfService/Navigation/LogoutButton';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeHandler: PropTypes.func.isRequired,
  navigationItems: PropTypes.array.isRequired,
  showContent: PropTypes.bool,
};

class SideNavigationOverlay extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.isOpen && nextProps.isOpen) {
      const classes = document.body.className;
      document.body.className = `${classes} overlay-open`;
    } else if (this.props.isOpen && !nextProps.isOpen) {
      const classes = document.body.className.replace('overlay-open', '');
      document.body.className = classes;
    }
  }

  onSidebarTouch(e) {
    e.stopPropagation();
  }

  render() {
    const {
      isOpen,
      closeHandler,
      navigationItems,
      showContent,
      ...rest
    } = this.props;

    if (!isOpen) {
      return null;
    }

    return createPortal(
      <div className="overlay" onTouchStart={closeHandler}>
        <div className="mobile-nav-sidebar" onTouchStart={this.onSidebarTouch}>
          {showContent
            && (
            <MainNavigation
              navigationItems={navigationItems}
              navigationItemClickHandler={closeHandler}
            />
            )}
          <div className="mobile-nav-sidebar__bottom txt-right">
            <LogoutButton {...rest} />
          </div>
        </div>
      </div>,
      document.querySelector('#app-overlays')
    );
  }
}

SideNavigationOverlay.propTypes = propTypes;

export default SideNavigationOverlay;
